module.exports = __webpack_public_path__ + "media/src/images/deliverylogo-fa4bd45a65a537a61018771a58c43606.svg";